import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "language__menu mr-4 mt-4 text-2xl" }
const _hoisted_2 = ["onClick"]

import { onBeforeUnmount, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

type LanguageType = {
    label: string;
    key: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageMenu',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const languages = ref<LanguageType[]>([
    {
        label: "Deutsch",
        key: "de"
    },
    {
        label: "Français",
        key: "fr"
    },
    {
        label: "English",
        key: "en"
    }
]);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
      return (_openBlock(), _createElementBlock("div", {
        key: language.key,
        class: _normalizeClass(["language__button flex justify-end mb-3", {
            'border-b-2 border-b-yellow-400 text-yellow-400': _unref(route).params.language === language.key
        }]),
        onClick: ($event: any) => (_unref(router).push({params: {language: language.key}}))
      }, [
        _createElementVNode("span", null, _toDisplayString(language.label), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})